import { ClassicEditor } from "@ckeditor/ckeditor5-editor-classic";
//import ContextualBalloon from "@ckeditor/ckeditor5-ui";
import { Essentials as EssentialsPlugin } from "@ckeditor/ckeditor5-essentials";
import { Bold as BoldPlugin, Italic as ItalicPlugin, Subscript, Superscript } from "@ckeditor/ckeditor5-basic-styles";
import FullScreen from "@/components/ckeditor/fullScreen";
import { Link as LinkPlugin, LinkImage } from "@ckeditor/ckeditor5-link";
import { List, ListProperties } from '@ckeditor/ckeditor5-list';
import { Heading as HeadingPlugin } from '@ckeditor/ckeditor5-heading';
import { Paragraph as ParagraphPlugin } from "@ckeditor/ckeditor5-paragraph";
import { SourceEditing } from "@ckeditor/ckeditor5-source-editing";
import { Image, ImageCaption, ImageResize, ImageStyle, ImageToolbar, ImageUpload } from '@ckeditor/ckeditor5-image';
import { Indent, IndentBlock } from '@ckeditor/ckeditor5-indent';
import { SimpleUploadAdapter } from "@ckeditor/ckeditor5-upload";
import { Alignment } from '@ckeditor/ckeditor5-alignment';
import { Font } from '@ckeditor/ckeditor5-font';
import { RemoveFormat } from '@ckeditor/ckeditor5-remove-format';
import { Table, TableToolbar } from '@ckeditor/ckeditor5-table';
import ExtendHtmlSupport from "./ckeditor/ExtendHtmlSupport";
import VueLink from "./ckeditor/VueLink/VueLinkUI";
const Editors = {
    Default: {
        type: ClassicEditor,
        config: {
            licenseKey: "GPL",
            plugins: [
                EssentialsPlugin,
                BoldPlugin,
                Subscript,
                Superscript,
                FullScreen,
                ItalicPlugin,
                LinkPlugin,
                ParagraphPlugin,
                HeadingPlugin,
                ExtendHtmlSupport,
                VueLink,
                SourceEditing,
                Indent,
                IndentBlock,
                Image,
                ImageCaption,
                ImageStyle,
                ImageToolbar,
                ImageUpload,
                ImageResize,
                LinkImage,
                SimpleUploadAdapter,
                Alignment,
                List,
                ListProperties,
                Font,
                RemoveFormat,
                Table,
                TableToolbar,
            ],
            toolbar: {
                items: ["heading", "|", "fontFamily", "fontSize", "fontColor", "fontBackgroundColor", "alignment", "bold", "italic", "vueLink", "|", "subscript", "superscript", "insertTable", "bulletedList", "numberedList", "outdent", "indent", "|", "uploadImage", "undo", "redo", "removeFormat", "|", "sourceEditing", "fullScreen",],
                shouldNotGroupWhenFull: true
            },
            image: {
                toolbar: [
                    'linkImage',
                    //'imageTextAlternative',
                    'toggleImageCaption',
                    '|',
                    'imageStyle:alignLeft',
                    'imageStyle:block',
                    'imageStyle:alignRight'
                ]
            },
            list: {
                property: {
                    styles: true,
                    startIndex: false,
                    reversed: false
                }
            },
            table: {
                contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"]
            },
            simpleUpload: {
                // https://ckeditor.com/docs/ckeditor5/latest/features/images/image-upload/simple-upload-adapter.html
                uploadUrl: process.env.VUE_APP_API + "api/v2/cms/upload",
            },
            fontColor: {
                colors: [
                    {
                        color: '#75787B',
                        label: 'Boyden Gray'
                    },
                    {
                        color: '#009FDF',
                        label: 'Boyden Blue'
                    },
                    {
                        color: '#D9017A',
                        label: 'Boyden Magenta'
                    },
                    {
                        color: '#F6E500',
                        label: 'Boyden Yellow'
                    },
                    {
                        color: '#000000',
                        label: 'Black'
                    },
                    {
                        color: '#fb3707',
                        label: 'Boyden Orange'
                    },
                    {
                        color: '#73b404',
                        label: 'Boyden Green'
                    },
                    {
                        color: '#603d20',
                        label: 'Boyden Brown'
                    },
                    {
                        color: '#8031a7',
                        label: 'Boyden Purple'
                    }
                ]
            },
            fontBackgroundColor: {
                colors: [
                    {
                        color: '#75787B',
                        label: 'Boyden Gray'
                    },
                    {
                        color: '#009FDF',
                        label: 'Boyden Blue'
                    },
                    {
                        color: '#D9017A',
                        label: 'Boyden Magenta'
                    },
                    {
                        color: '#F6E500',
                        label: 'Boyden Yellow'
                    },
                    {
                        color: '#000000',
                        label: 'Black'
                    },
                    {
                        color: '#fb3707',
                        label: 'Boyden Orange'
                    },
                    {
                        color: '#73b404',
                        label: 'Boyden Green'
                    },
                    {
                        color: '#603d20',
                        label: 'Boyden Brown'
                    },
                    {
                        color: '#8031a7',
                        label: 'Boyden Purple'
                    }
                ]
            },
            link: {
                decorators: {
                    openInNewTab: {
                        mode: 'manual',
                        label: 'Open in a new tab',
                        defaultValue: true,
                        attributes: {
                            target: "_blank",
                            rel: "noopener noreferrer"
                        }
                    }
                }
            },
            htmlSupport: {
                allow: [
                    {
                        name: /.*/,
                        styles: true,
                        classes: true,
                        attributes: true
                    }
                ],
                disallow: [
                    {
                        name: /wc-.*/
                    }
                ]
            }
        }
    },
    Assessment: {
        type: ClassicEditor,
        config: {
            licenseKey: "GPL",
            plugins: [
                EssentialsPlugin,
                BoldPlugin,
                Subscript,
                Superscript,
                FullScreen,
                ItalicPlugin,
                LinkPlugin,
                ParagraphPlugin,
                HeadingPlugin,
                ExtendHtmlSupport,
                VueLink,
                SourceEditing,
                Indent,
                IndentBlock,
                Image,
                ImageCaption,
                ImageStyle,
                ImageToolbar,
                ImageUpload,
                ImageResize,
                LinkImage,
                SimpleUploadAdapter,
                Alignment,
                List,
                ListProperties,
                Font,
                RemoveFormat,
                Table,
                TableToolbar,
            ],
            toolbar: {
                items: ["bold", "italic", "|", "bulletedList", "numberedList", "outdent", "indent", "|", "removeFormat"],
                shouldNotGroupWhenFull: true
            },
            image: {
                toolbar: [
                    'linkImage',
                    //'imageTextAlternative',
                    'toggleImageCaption',
                    '|',
                    'imageStyle:alignLeft',
                    'imageStyle:block',
                    'imageStyle:alignRight'
                ]
            },
            list: {
                property: {
                    styles: true,
                    startIndex: false,
                    reversed: false
                }
            },
            table: {
                contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"]
            },
            simpleUpload: {
                // https://ckeditor.com/docs/ckeditor5/latest/features/images/image-upload/simple-upload-adapter.html
                uploadUrl: process.env.VUE_APP_API + "api/v2/cms/upload",
            },
            fontColor: {
                colors: [
                    {
                        color: '#75787B',
                        label: 'Boyden Gray'
                    },
                    {
                        color: '#009FDF',
                        label: 'Boyden Blue'
                    },
                    {
                        color: '#D9017A',
                        label: 'Boyden Magenta'
                    },
                    {
                        color: '#F6E500',
                        label: 'Boyden Yellow'
                    },
                    {
                        color: '#000000',
                        label: 'Black'
                    },
                    {
                        color: '#fb3707',
                        label: 'Boyden Orange'
                    },
                    {
                        color: '#73b404',
                        label: 'Boyden Green'
                    },
                    {
                        color: '#603d20',
                        label: 'Boyden Brown'
                    },
                    {
                        color: '#8031a7',
                        label: 'Boyden Purple'
                    }
                ]
            },
            fontBackgroundColor: {
                colors: [
                    {
                        color: '#75787B',
                        label: 'Boyden Gray'
                    },
                    {
                        color: '#009FDF',
                        label: 'Boyden Blue'
                    },
                    {
                        color: '#D9017A',
                        label: 'Boyden Magenta'
                    },
                    {
                        color: '#F6E500',
                        label: 'Boyden Yellow'
                    },
                    {
                        color: '#000000',
                        label: 'Black'
                    },
                    {
                        color: '#fb3707',
                        label: 'Boyden Orange'
                    },
                    {
                        color: '#73b404',
                        label: 'Boyden Green'
                    },
                    {
                        color: '#603d20',
                        label: 'Boyden Brown'
                    },
                    {
                        color: '#8031a7',
                        label: 'Boyden Purple'
                    }
                ]
            },
            link: {
                decorators: {
                    openInNewTab: {
                        mode: 'manual',
                        label: 'Open in a new tab',
                        defaultValue: true,
                        attributes: {
                            target: "_blank",
                            rel: "noopener noreferrer"
                        }
                    }
                }
            },
            htmlSupport: {
                allow: [
                    {
                        name: /.*/,
                        styles: true,
                        classes: true,
                        attributes: true
                    }
                ],
                disallow: [
                    {
                        name: /wc-.*/
                    }
                ]
            }
        }
    }
};
export { Editors };
